import { render } from "./FourthPage.vue?vue&type=template&id=404d6973"
import script from "./FourthPage.vue?vue&type=script&lang=js"
export * from "./FourthPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__